import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

/**
 * Component that displays a message with a countdown timer before redirecting
 * @param {number} props.seconds - Number of seconds before redirection
 * @param {string} props.pageName - Name of the page to display in the message
 * @param {string} props.redirectPath - Redirection path
 * @returns {JSX.Element} Redirection message with countdown
 */
export const RedirectMessage = ({ seconds, pageName, redirectPath }) => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    if (timeLeft === 0) {
      navigate(redirectPath);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, navigate, redirectPath]);

  return (
    <div style={{ textAlign: "center", marginTop: 16 }}>
      <p>
        You will be redirected to the {pageName} page in {timeLeft} seconds
      </p>
      <p>
        Or click{" "}
        <Link to={redirectPath} style={{ textDecoration: "underline" }}>
          here
        </Link>{" "}
        to go now
      </p>
    </div>
  );
};
